const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/PhoneLink.tsx';
import { css, cx } from '@emotion/css';
import { theme } from 'App/utils/clientSetupManager';
import { LinkHrefTagFrame } from 'App/components/old_components/components/LinkFrame';
import * as React from 'react';

const styleIcon: React.CSSProperties = {
    color: theme.palette.primary.main,
    fontSize: theme.spacing(2.5),
};
const geoCellStyle = css`
    grid-column: 2;
    margin-top: ${theme.spacing(1)};
    color: ${theme.palette.primary.main};
`;

export interface Props {
    phone: string;
    className?: string;
}

export const PhoneLinkComponent = (props: Props) => {
    const phone = props.phone;
    const phoneLink = phone ? `tel:${phone.replace(' ', '')}` : '';

    return (
        <LinkHrefTagFrame
            className={cx(geoCellStyle, props.className)}
            styleIcon={styleIcon}
            text={phone}
            href={phoneLink}
            iconName="icons8-phone"
        />
    );
};
